import SearchPage from '../search_page';
import searchPageStateManager from '../search_page_state_manager';

export default function(store) {
  return {
    path: '/search/:q?/:page?',
    component: SearchPage,
    exact: true,
    strict: true,
    loadData: searchPageStateManager(store)
  };
}
